import { TFunction } from "i18next";
import * as yup from "yup";

export interface TeacherValidationSchemeProps {
    t: TFunction;
}

export const TeacherValidationScheme = ({
    t,
  }: TeacherValidationSchemeProps) => {
    const requiredMsg = t("validations.required");
    const documentTooBig = t("errorCode.Document.TooBig");
    const documentWrongFormat = t("errorCode.Document.WrongFormat");
    const requiredAtLeastOneLanguage = t("validations.requiredAtLeastOneLanguage");
    const requiredOibCheck = t("validations.requiredOibCheck");
    const dateFromLessThanDateTo = t("validations.dateFromLessThanDateTo");

    return yup.object().shape({
      oib: yup.string().required(requiredMsg),
      firstName: yup.string().required(requiredMsg),
      lastName: yup.string().required(requiredMsg),
      programRequestClassEnsambles: yup.array().of(
        yup.object().shape(
          {
            ensamble: yup.string().required(requiredMsg)
          }
        )            
      ).min(1, requiredMsg),
      languages: yup.array().of(
        yup.object().shape(
          {
            language: yup.object().nullable().required(requiredMsg),
            dateFrom: yup.date().when("dateTo", (dateTo, schema) => {
              if(dateTo){
                return yup.date().max(dateTo, dateFromLessThanDateTo);
              }
              else{
                return schema;
              }

            }),
            certificationDocument: yup.mixed().nullable().required(requiredMsg).test('certificationDocument', documentTooBig, val => {
              if(val && val.id !== -1){
                return true;
              }
              if(val && val.file.size <= 10485760){
                return true;
              }
              return false;
            }).test('certificationDocument', documentWrongFormat, val => {
              if(val){
                var split = val.fileName.split('.');
                var ext = split[split.length - 1];
              
                if(ext === "pdf" || ext === "jpg" || ext === "jpeg" || ext === "png" || ext === "gif" || ext === "tiff" || ext === "bmp"){
                 return true;
                }
              }
        
              return false;
            }),
          }
        )
        ).when("isLanguageMandatory", {is: true, then: yup.array().min(1, requiredAtLeastOneLanguage), otherwise: yup.array().nullable()}),      
      statement: yup.mixed().required(requiredMsg).test('statement', documentTooBig, val => {             
        if(val && val.id !== -1){          
          return true;
        }
        if(val && val.file.size <= 10485760){          
          return true;
        }        
        return false;
      }).test('statement', documentWrongFormat, val => {
        if(val){
          var split = val.fileName.split('.');
          var ext = split[split.length - 1];
        
          if(ext === "pdf" || ext === "jpg" || ext === "jpeg" || ext === "png" || ext === "gif" || ext === "tiff" || ext === "bmp"){
           return true;
          }
        }
  
        return false;
      }),
      diplomaDocument: yup.mixed().required(requiredMsg).test('diplomaDocument', documentTooBig, val => {
        if(val && val.id !== -1){
          return true;
        }
        if(val && val.file.size <= 10485760){
          return true;
        }
        return false;
      }).test('diplomaDocument', documentWrongFormat, val => {
        if(val){
          var split = val.fileName.split('.');
          var ext = split[split.length - 1];
        
          if(ext === "pdf" || ext === "jpg" || ext === "jpeg" || ext === "png" || ext === "gif" || ext === "tiff" || ext === "bmp"){
           return true;
          }
        }
  
        return false;
      }),
      additionalDocumentation: yup.mixed().nullable().test('additionalDocumentation', documentTooBig, val => {           
        if(val === null || val === undefined || (val && val.id !== -1)){
          return true;
        }
        if(val && val.file.size <= 10485760){
          return true;
        }
        return false;      
      }),
      oibChecked: yup.boolean().test('oibChecked', requiredOibCheck, val => {
        if(val !== null && val !== undefined && val === false){
          return false;
        }
        return true;
      })
    });
}
